import {FormikHandlers} from 'formik'

export type TSelectOption = {
    label: string
    value: string | number
    innerValue?: string | number
    menu_label: string
    icon_url?: string
}
export type TSelectValue = TSelectOption | Array<TSelectOption> | null

export type TDefaultSelect = {
    placeholder?: string
    list?: Array<{
        title: string
        value: string | number | boolean
        menu_title?: string | undefined
        [key: string]: any
    }>
    is_checkboxOption?: boolean
    is_checkboxDropdown?: boolean
    isMulti?: boolean
    isDisabled?: boolean
    isVisible?: boolean
    isClearable?: boolean
    isDuplicate?: boolean
    prefix?: string
    isSearchable?: boolean
    menuPortal?: boolean
    isLoading?: boolean
    object?: string
    select?: Array<string> | string
    select_menu?: Array<string> | string
    formValue: any
    joinedFieldValue: {[key: string]: any} | null
    isError: boolean
    error?: string
    withColor?: boolean
    showAllTags?: boolean
    handleChange: (value: any) => void
    handleAppendDuplicate: (label: any, prevValue: any) => void
    handleBlur: FormikHandlers['handleBlur']
    reloadKey?: number
    settings?: any
}

export type TSearchSelect = {
    placeholder?: string
    isMulti?: boolean
    isDisabled?: boolean
    isVisible?: boolean
    isClearable?: boolean
    search?: string
    prefix?: string
    menuPortal?: boolean
    isDuplicate?: boolean
    isError: boolean
    formValue: any
    joinedFieldValue: {[key: string]: any} | null
    value: any
    error?: string
    select?: Array<string> | string
    select_menu?: Array<string> | string
    withColor?: boolean
    article?: string
    setValue: (value: any) => void
    handleChange: (value: any) => void
    handleAppendDuplicate: (label: any, prevValue: any) => void
    handleBlur: FormikHandlers['handleBlur']
    setValueForHook?: (value: any) => void
    onLabelResolved?: (label: string | null) => void
    is_checkboxOption?: boolean
    showAllTags?: boolean
    settings?: any
}

export type TComponentSelect = {
    article: string
    data_type: 'integer' | 'string' | 'boolean' | 'array'
    placeholder?: string
    list?: Array<{
        title: string
        value: string | number | boolean
        joined_field_value?: string
        menu_title?: string
    }>
    isMulti?: boolean
    isDisabled?: boolean
    isVisible?: boolean
    isClearable?: boolean
    isDuplicate?: boolean
    isLoading?: boolean
    joined_field?: Array<string> | string
    joined_field_filter?: Array<string> | string
    object?: string
    select?: Array<string> | string
    select_menu?: Array<string> | string
    search?: string
    hook?: string
    onChangeSubmit?: boolean
    customHandler?: (value: any) => void
    prefix?: string
    menuPortal?: boolean
    isSearchable?: boolean
    withColor?: boolean
    is_checkboxOption?: boolean
    is_checkboxDropdown?: boolean
    showAllTags?: boolean
    reloadKey?: number
    settings?: any
}

export const MAX_VISIBLE_TAGS = 3

export type TTagsCollapseSelectProps = {
    isTagsExpanded: boolean
    onToggleTagsExpanded: () => void
    maxVisibleTags: number
}
